import React from 'react';
import { Button, Dropdown, Badge, Menu, Empty, Row, Typography, Avatar } from 'antd';
import { 
  BellOutlined, 
  ShoppingCartOutlined, 
  EyeInvisibleOutlined, 
  EyeOutlined,
  UserOutlined,
  HomeOutlined
} from '@ant-design/icons';
import './TopBarStyles.css';
import Logo from "../../../images/logo.png";
import { useNavigate, useLocation } from 'react-router-dom';

const { Title } = Typography;

const TopBar = ({ title }) => {
  let history = useNavigate();
  const location = useLocation();
  
  const isCartPage = location.pathname === "/marketplace/shopping-cart";
  const user = JSON.parse(localStorage.getItem('user'));

  const notifications = {
    notify: [],
    total: 0,
  };

  const shoppingCartClick = () => {
    history('/marketplace/shopping-cart');
  };

  const allNotifications = (
    <Menu className="notifications-menu">
      <Menu.ItemGroup title="Notificaciones" className="notifications-header">
        {notifications.total === 0 ? ( 
          <div className="empty-notifications">
            <Empty 
              description="Sin notificaciones" 
              image={Empty.PRESENTED_IMAGE_SIMPLE} 
            />
          </div>
        ) :
          notifications.notify.map((ntf) => (
            <Menu.Item 
              key={ntf.id} 
              className={`notification-item ${ntf.seen === 0 ? 'unread' : 'read'}`}
              icon={ntf.seen === 0 ? 
                <EyeInvisibleOutlined className="notification-icon unread-icon" /> : 
                <EyeOutlined className="notification-icon read-icon" />
              } 
            >
              <button 
                className="notification-button"
                onClick={() => {}}
              >
                <div className="notification-content">
                  <div className="notification-title">{ntf.title}</div>
                  <div className="notification-description">{ntf.description}</div>
                </div>
              </button>
            </Menu.Item>
          ))
        }
      </Menu.ItemGroup>
    </Menu>
  );

  const handleEnableNotifications = () => {
    if (Notification.permission === 'denied') {
      return;
    }

    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        // Notifications enabled logic can be added here if needed
      }
    });
  };

  const handleUserProfile = () => {
    history('/profile');
  };

  const handleGoHome = () => {
    history('/marketplace');
  };

  return (
    <div className={`top-banner-wrapper ${isCartPage ? 'cart-page-header' : ''}`}>
      {/* Top Bar Principal */}
      <div className="top-bar-main">
        <div className="top-bar-left">
          <div className="logo-section">
            <img 
              src={Logo} 
              alt="Logo" 
              className="logo-img" 
              onClick={handleGoHome}
            />
          </div>
        </div>

        <div className="top-bar-center">
          {title && (
            <div className="page-title-section">
              <Title level={2} className="page-title">
                {title}
              </Title>
            </div>
          )}
        </div>

        <div className="top-bar-right">
          {/* Botón Inicio */}
          <Button 
            className="nav-button"
            icon={<HomeOutlined />}
            onClick={handleGoHome}
            type="text"
          >
            Inicio
          </Button>

          {/* Notificaciones */}
          <Dropdown 
            overlay={allNotifications} 
            placement="bottomRight"
            trigger={['click']}
            overlayClassName="notifications-dropdown"
          >
            <Badge 
              count={notifications.total} 
              overflowCount={99} 
              className="notification-badge"
            >
              <Button 
                shape="circle" 
                className="icon-button" 
                icon={<BellOutlined />} 
                onClick={handleEnableNotifications}
              />
            </Badge>
          </Dropdown>

          {/* Avatar de Usuario */}
          <div className="user-avatar">
            <Avatar 
              size="default"
              icon={<UserOutlined />}
              src={user?.avatar}
              className="avatar"
              // onClick={handleUserProfile} Se comenta en lo que se crea un perfil de usuario.
            />
            <span className="user-name">
              {user?.name?.split(' ')[0] || 'Usuario'}
            </span>
          </div>
        </div>
      </div>

      {/* Banner de Título (Solo si no es página del carrito) */}
      {!isCartPage && title && (
        <div className="title-banner">
          <div className="banner-content">
            <Title level={1} className="banner-title">
              {title}
            </Title>
          </div>
        </div>
      )}
    </div>
  );
};

export default TopBar;